import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

function LinkRequestDialog({ open, onClose, currentUserId, onSubmit, loading }) {
  const [targetIdentifier, setTargetIdentifier] = useState("");

  const trimmed = targetIdentifier.trim();
  const isInvalid = trimmed !== "" && !EMAIL_RE.test(trimmed);
  const submitDisabled = !trimmed || isInvalid || loading;

  const handleClose = () => {
    setTargetIdentifier("");
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitDisabled) return;
    await onSubmit(trimmed);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Link New Account</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Enter the email address of the account you want to link with.
          </DialogContentText>
          <TextField
            autoFocus
            label="Target Email"
            fullWidth
            required
            value={targetIdentifier}
            onChange={(e) => setTargetIdentifier(e.target.value)}
            helperText={
              isInvalid
                ? "Enter a valid email address."
                : "Enter the account holder's email address."
            }
            error={isInvalid}
            disabled={loading}
            inputProps={{ "data-testid": "link-request-target-identifier" }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={submitDisabled}
            data-testid="link-request-submit"
          >
            Send Request
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default LinkRequestDialog;
